<template>
  <div class="order-detail-content">
    <div class="order-detail-item order-detail-status">
      <div class="order-detail-audit-status">

        <div class="color-black bold">
          订单审核状态：{{ orderDetail.status_name }}
        </div>
        <!-- <div
          v-if="orderDetail.extra.fail_message"
          class="font-size14"
        >
          失败原因：{{ orderDetail.extra.fail_message }}
        </div> -->
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        学员信息
      </div>
      <div class="order-detail-student">
        <div class="order-detail-people-name">
          <span
            class="order-detail-student-name"
          >学员姓名： {{ orderDetail.sub_name }}</span>
          <span>就读小学：{{ orderDetail.school_name }}</span>
          <span>就读年级：{{ orderDetail.grade_name }}</span>
        </div>
        <!-- <div class="order-detail-people-name">
          <span
            class="order-detail-student-name"
          >家长姓名：{{ orderDetail.master_info.master_name }}</span>
          <span>家长电话：{{ orderDetail.master_info.mobile }}</span>
        </div> -->
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        套餐信息
      </div>
      <div class="order-detail-package">
        <h4>购买套餐信息</h4>
        <div v-for="item in orderDetail.order_list" :key="item.id">
          {{ item.item_title }}
        </div>

      </div>
      <div v-if="orderDetail.combine_list && orderDetail.combine_list.length>0" class="order-detail-package" style="margin-top:10px">
        <div>赠送小学生课时</div>
        <div>课时信息：</div>
        <el-table :data="orderDetail.combine_list">
          <el-table-column prop="subject_name" label="科目" />
          <el-table-column prop="course_type_name" label="类型" />
          <el-table-column prop="num" label="课次(天)" />
        </el-table>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        签约信息
      </div>
      <div class="order-detail-package">
        <div>签约单号：{{ orderDetail.out_trade_no }}</div>
        <div>实际支付：¥{{ orderDetail.amount / 100 }}</div>
        <h4>其他费用信息</h4>
        <div v-for="item in orderDetail.discounts_total" :key="item.id">
          {{ item.classify_name }}：¥{{ item.value / 100 }}
        </div>
        <div v-if="orderDetail.payment_name">
          支付方式：{{ orderDetail.payment_name }}
        </div>
        <div v-if="orderDetail.extra && orderDetail.extra.topay_time">
          支付时间：{{ orderDetail.extra.topay_time }}
        </div>
        <div v-if="orderDetail.extra && orderDetail.extra.topay_info">
          财务单号：{{ orderDetail.extra.topay_info }}
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        责任人信息
      </div>
      <div class="order-detail-sales">
        <div class="order-detail-people-name">
          <span>提交人：{{ orderDetail.editor_name }}</span>
          <!-- <span>班主任：{{ orderDetail.headmaster_name }}</span> -->
        </div>
      </div>
    </div>
    <div v-if="type == 'signingAudit'" class="order-audit-btn">
      <div class="order-audit-btn-title">上传支付凭证</div>

      <qiniu-upload ref="'uploadqiniu'" :files="uploadFiles" :up-type="`payment_document/${today}`" :limit="1" :auto-upload="true" @success="uploadSuccess" />

      <el-row type="flex" justify="end">
        <el-input
          v-model="success_remark"
          clearable
          placeholder="请输入财务流水单号"
        />
        <el-button type="primary" @click="auditSuccess">审核成功</el-button>
      </el-row>
      <el-row type="flex" justify="end">
        <el-input
          v-model="fail_remark"
          clearable
          placeholder="请输入失败原因"
        />
        <el-button type="info" @click="auditFail">审核失败</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>

import qiniuUpload from '@/components/FormBox/QiniuUpload.vue'
var moment = require('moment')
export default {
  name: 'OrderSigningInfo',
  components: {
    qiniuUpload
  },
  filters: {
    orderStatus(val1, val2) {
      if (val1 == '0') {
        return '待校长审核'
      } else if (val1 == '1' && val2 == '6') {
        return '待总部审核'
      } else if (val1 == '1' && val2 != '6') {
        return '待财务审核'
      } else if (val1 == '2') {
        return '审核成功'
      } else if (val1 == '3') {
        return '审核失败'
      }
    },
    payType(val) {
      if (val == 'alipay') {
        return '支付宝'
      } else if (val == 'lkl') {
        return 'POS支付'
      } else if (val == 'turn') {
        return '直接转账'
      } else if (val == 'cash') {
        return '现金支付'
      } else if (val == 'bank') {
        return '银行卡'
      } else if (val == 'wxqr') {
        return '微信'
      }
    }
  },
  props: {
    orderDetail: {
      type: Object,
      default: () => ({

      })
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      success_remark: '',
      fail_remark: '',
      audit_status: '',
      pzFiles: '',
      uploadFiles: [],
      today: moment().format('YYYY-MM')
    }
  },
  methods: {
    uploadSuccess(e) {
      const { urls } = e
      this.pzFiles = urls.join(',')
      console.log('上传成功', this.pzFiles)
    },
    auditSuccess() {
      if (!this.success_remark) {
        this.$message({
          type: 'info',
          message: '请输入财务流水单号'
        })
        return
      }
      // if (!this.pzFiles) {
      //   this.$message({
      //     type: 'info',
      //     message: '请上传支付凭证'
      //   })
      //   return
      // }
      const obj = {
        out_trade_no: this.orderDetail.out_trade_no,
        remark: this.success_remark,
        status: 2,
        payment_document: this.pzFiles || ''
      }
      this.$http.auditBilling(obj).then(() => {
        this.$emit('updateOrderList')
      })
    },
    auditFail() {
      if (!this.fail_remark) {
        this.$message({
          type: 'info',
          message: '请填写审核失败原因'
        })
        return
      }
      const obj = {
        out_trade_no: this.orderDetail.out_trade_no,
        remark: this.fail_remark,
        status: 106
      }
      this.$http.auditBilling(obj).then(res => {
        if (res.code == 200) {
          this.$emit('updateOrderList')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.order-detail-dialog .el-dialog__body {
  height: 700px;
  padding: 20px 30px;
  overflow: auto;
  .order-detail-content {
    line-height: 24px;
    .order-detail-item {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f5f5f5;
    }
    .order-detail-status {
      padding: 15px 20px;
      background-color: #f5f5f5;
    }
    .order-detail-item-title {
      margin-bottom: 15px;
    }
    .order-detail-people-name span {
      margin-right: 30px;
    }
    .order-detail-student-name {
      width: 160px;
    }
    .el-table {
      margin-top: 10px;
    }
    .el-table tr th {
      height: 34px !important;
      background: #fff !important;
      color: #333;
    }
    .el-table td,
    .el-table th {
      padding: 4px;
      border: 1px solid #f5f5f5;
    }
  }
  .order-audit-btn {
    .el-row {
      margin-bottom: 10px;
    }
    .el-input {
      margin-right: 20px;
    }
  }
  .special-table {
    width: 100%;
    margin: 30px 0;
    border: 1px solid #f5f5f5;
    tr,
    th,
    td {
      text-align: center;
      padding: 10px 0;
      border: 1px solid #f5f5f5;
    }
  }
}
</style>
